import api from '../callApi';

export const apiGetVolunteerOpportunities = (
    zipCode,
    countryCode,
    actionVolunteerId,
    useOnlyCached
) =>
    api
        .get(
            `Localization/GetVolunteerOpportunitiesAsync?zipCode=${zipCode}&actionVolunteerId=${actionVolunteerId}&useOnlyCache=${useOnlyCached}&country=${countryCode}`
        )
        .then(response => response);

export const apiCompleteVolunteerSignup = request =>
    api.post(`Widget/CompleteVolunteerAsync`, request).then(response => response);



// WEBPACK FOOTER //
// ./src/utils/volunteer/volunteerApi.js